/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { floorplanControllerCreate } from '../fn/floorplan/floorplan-controller-create';
import { FloorplanControllerCreate$Params } from '../fn/floorplan/floorplan-controller-create';
import { floorplanControllerDelete } from '../fn/floorplan/floorplan-controller-delete';
import { FloorplanControllerDelete$Params } from '../fn/floorplan/floorplan-controller-delete';
import { floorplanControllerFindAllByClientId } from '../fn/floorplan/floorplan-controller-find-all-by-client-id';
import { FloorplanControllerFindAllByClientId$Params } from '../fn/floorplan/floorplan-controller-find-all-by-client-id';
import { floorplanControllerFindById } from '../fn/floorplan/floorplan-controller-find-by-id';
import { FloorplanControllerFindById$Params } from '../fn/floorplan/floorplan-controller-find-by-id';
import { floorplanControllerFindHistory } from '../fn/floorplan/floorplan-controller-find-history';
import { FloorplanControllerFindHistory$Params } from '../fn/floorplan/floorplan-controller-find-history';
import { floorplanControllerUpdate } from '../fn/floorplan/floorplan-controller-update';
import { FloorplanControllerUpdate$Params } from '../fn/floorplan/floorplan-controller-update';
import { floorplanControllerUpsertDevices } from '../fn/floorplan/floorplan-controller-upsert-devices';
import { FloorplanControllerUpsertDevices$Params } from '../fn/floorplan/floorplan-controller-upsert-devices';
import { FloorplanDto } from '../models/floorplan-dto';
import { FloorplanHistoryDto } from '../models/floorplan-history-dto';

@Injectable({ providedIn: 'root' })
export class FloorplanService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `floorplanControllerFindAllByClientId()` */
  static readonly FloorplanControllerFindAllByClientIdPath = '/api/floorplan/all/{clientWorkspaceId}';

  /**
   * 고객사 기반 배치도 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerFindAllByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerFindAllByClientId$Response(params: FloorplanControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FloorplanDto>>> {
    return floorplanControllerFindAllByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 기반 배치도 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerFindAllByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerFindAllByClientId(params: FloorplanControllerFindAllByClientId$Params, context?: HttpContext): Observable<Array<FloorplanDto>> {
    return this.floorplanControllerFindAllByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FloorplanDto>>): Array<FloorplanDto> => r.body)
    );
  }

  /** Path part for operation `floorplanControllerFindHistory()` */
  static readonly FloorplanControllerFindHistoryPath = '/api/floorplan/{clientWorkspaceId}/{id}/history';

  /**
   * 배치도 변경 이력 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerFindHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerFindHistory$Response(params: FloorplanControllerFindHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FloorplanHistoryDto>>> {
    return floorplanControllerFindHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 변경 이력 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerFindHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerFindHistory(params: FloorplanControllerFindHistory$Params, context?: HttpContext): Observable<Array<FloorplanHistoryDto>> {
    return this.floorplanControllerFindHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FloorplanHistoryDto>>): Array<FloorplanHistoryDto> => r.body)
    );
  }

  /** Path part for operation `floorplanControllerFindById()` */
  static readonly FloorplanControllerFindByIdPath = '/api/floorplan/{clientWorkspaceId}/{id}';

  /**
   * 배치도 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerFindById$Response(params: FloorplanControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
    return floorplanControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerFindById(params: FloorplanControllerFindById$Params, context?: HttpContext): Observable<FloorplanDto> {
    return this.floorplanControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorplanDto>): FloorplanDto => r.body)
    );
  }

  /** Path part for operation `floorplanControllerDelete()` */
  static readonly FloorplanControllerDeletePath = '/api/floorplan/{clientWorkspaceId}/{id}';

  /**
   * 배치도 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerDelete$Response(params: FloorplanControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
    return floorplanControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorplanControllerDelete(params: FloorplanControllerDelete$Params, context?: HttpContext): Observable<FloorplanDto> {
    return this.floorplanControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorplanDto>): FloorplanDto => r.body)
    );
  }

  /** Path part for operation `floorplanControllerUpdate()` */
  static readonly FloorplanControllerUpdatePath = '/api/floorplan/{clientWorkspaceId}/{id}';

  /**
   * 배치도 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorplanControllerUpdate$Response(params: FloorplanControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
    return floorplanControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorplanControllerUpdate(params: FloorplanControllerUpdate$Params, context?: HttpContext): Observable<FloorplanDto> {
    return this.floorplanControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorplanDto>): FloorplanDto => r.body)
    );
  }

  /** Path part for operation `floorplanControllerCreate()` */
  static readonly FloorplanControllerCreatePath = '/api/floorplan/{clientWorkspaceId}';

  /**
   * 배치도 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorplanControllerCreate$Response(params: FloorplanControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
    return floorplanControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorplanControllerCreate(params: FloorplanControllerCreate$Params, context?: HttpContext): Observable<FloorplanDto> {
    return this.floorplanControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorplanDto>): FloorplanDto => r.body)
    );
  }

  /** Path part for operation `floorplanControllerUpsertDevices()` */
  static readonly FloorplanControllerUpsertDevicesPath = '/api/floorplan/{clientWorkspaceId}/{id}/devices';

  /**
   * 배치도 기기 배치 일괄 저장.
   *
   * 배치도에 배치된 기기 목록/좌표/색상을 한 번에 저장합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorplanControllerUpsertDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorplanControllerUpsertDevices$Response(params: FloorplanControllerUpsertDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
    return floorplanControllerUpsertDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * 배치도 기기 배치 일괄 저장.
   *
   * 배치도에 배치된 기기 목록/좌표/색상을 한 번에 저장합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorplanControllerUpsertDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorplanControllerUpsertDevices(params: FloorplanControllerUpsertDevices$Params, context?: HttpContext): Observable<FloorplanDto> {
    return this.floorplanControllerUpsertDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloorplanDto>): FloorplanDto => r.body)
    );
  }

}
